<longlist
  class="h-full w-full"
  [pageTitle]="'All Account Files'"
  [drawerOpened]="false"
  [showLongListActions]="true"
  [showRouterOutlet]="false"
  [longlistWithinVtab]="true"
  [showQuickSearch]="true"
  [showAdvancedSearch]="true"
  [appFilters]="appFilters"
  (quickSearchSelection)="onQuickSearchSelected($event)"
  (quickSearchFocused)="onQuickSearchFocused($event)"
  (filterButtonPressed)="toggleFilterPanel()">
  <longlist-actions class="flex flex-row items-center justify-end gap-2">
    <button color="default" (click)="onCancel()">
      <mat-icon svgIcon="mat_outline:close"></mat-icon>
    </button>
  </longlist-actions>
  <longlist-content>
    <div class="p-4 flex flex-col h-full min-h-0">
      <filter-group
        [appFilters]="appFilters"
        [toggleFilter]="toggleFilter"
        (toggleFilterChange)="toggleFilterPanel()"
        (filterChange)="onFilterChange($event)"
        (removeFilter)="onRemoveFilter($event)"
        (applyFilterButtonPressed)="onApplyFilterButtonPressed($event)"
        [showAdvancedSearch]="false"></filter-group>

      <div class="files-grid flex-1 min-h-0">
        <cipx-scrollable-content [noPadding]="true" [removeOverflowOnMobile]="false" class="md:col-span-2 flex flex-col min-h-0 h-full">
          <div class="pt-2 flex flex-col">
            <mat-paginator
              #paginatorTop
              class="flex justify-end border-b bg-slate-200 dark:bg-slate-900"
              aria-label="Select page of Documents"
              showFirstLastButtons
              [length]="total"
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="[10, 50, 100, 1000]"
              (page)="onPageChange($event)"
              hidePageSizeOptions
              hidePageSize></mat-paginator>

            <mat-progress-bar *ngIf="isLoading()" mode="indeterminate"></mat-progress-bar>
            <div *ngIf="isLoading()" class="text-center text-sm text-gray-500 py-2">Loading documents...</div>

            <div *ngIf="!isLoading()" class="flex-1">
              <table
                mat-table
                matSort
                [dataSource]="dataSource"
                (matSortChange)="onSortChange($event)"
                class="doug-table w-full">
                <!-- Select Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="w-12">
                    <mat-checkbox
                      (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      color="primary"></mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let file" class="w-12">
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="$event ? selectFile(file) : null"
                      [checked]="selection.isSelected(file)"
                      color="primary"></mat-checkbox>
                  </td>
                </ng-container>

                <!-- File Name Column -->
                <ng-container matColumnDef="file_name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
                  <td mat-cell *matCellDef="let file">
                    <div class="flex items-center gap-2 py-2">
                      <mat-icon [svgIcon]="getFileIcon(file.file_extension)" class="icon-size-5"></mat-icon>
                      <div class="flex flex-col">
                        <span class="font-medium">{{ file.file_provided_name || file.file_name }}</span>
                        <span class="text-xs text-gray-500">{{ file.file_purpose_label }}</span>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <!-- Shared Status Column -->
                <ng-container matColumnDef="is_shared_with_account">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Shared</th>
                  <td mat-cell *matCellDef="let file" class="text-center">
                    <mat-icon
                      [svgIcon]="
                        file.is_shared_with_account
                          ? 'heroicons_outline:check-circle'
                          : 'heroicons_outline:minus-circle'
                      "
                      [ngClass]="file.is_shared_with_account ? 'text-green-500' : 'text-gray-400'"
                      class="icon-size-5"></mat-icon>
                  </td>
                </ng-container>

                <!-- Shared Status Label Column -->
                <ng-container matColumnDef="shared_status_label_with_account">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Shared Status</th>
                  <td mat-cell *matCellDef="let file">
                    <span class="text-xs">{{ file.shared_status_label_with_account }}</span>
                  </td>
                </ng-container>

                <!-- Bond Column -->
                <ng-container matColumnDef="surety_bond_label">
                  <th mat-header-cell *matHeaderCellDef>Bond</th>
                  <td mat-cell *matCellDef="let file">
                    <div class="flex flex-col py-2">
                      <!-- Principal on top -->
                      <span class="font-medium text-xs">{{ file.company_name }}</span>

                      <!-- Order number with managed icon -->
                      <div class="flex items-center gap-1">
                        <a
                          [href]="file.quote_request_url"
                          target="_blank"
                          class="hover:underline flex items-center gap-1 text-xs"
                          (click)="$event.stopPropagation()">
                          {{ file.order_number }}
                          <mat-icon [svgIcon]="'heroicons_outline:external-link'" class="icon-size-3"></mat-icon>
                        </a>
                        <mat-icon
                          [svgIcon]="
                            file.quote_request_is_manage ? 'heroicons_outline:lock-open' : 'heroicons_outline:lock-closed'
                          "
                          [color]="file.quote_request_is_manage ? 'primary' : 'warn'"
                          class="icon-size-4"
                          [matTooltip]="file.quote_request_is_manage ? 'Managed' : 'Unmanaged'"></mat-icon>
                      </div>

                      <!-- Bond label and amount -->
                      <div class="text-xs text-gray-500">
                        {{ file.user_first_name }}
                        {{ file.user_last_name }}
                      </div>

                      <!-- Bond label and amount -->
                      <div class="text-xs text-gray-500">
                        {{ file.bond_amount | currency: 'USD' : 'symbol' : '1.0-0' }}
                        {{ file.state_abbreviation }}
                        {{ file.surety_bond_label }}
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                  (dblclick)="confirmSelection(row)"
                  [ngClass]="{ 'bg-blue-50 dark:bg-blue-900/20': false }"
                  class="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell text-center text-sm text-gray-500 py-4" [attr.colspan]="displayedColumns.length">
                    No documents found.
                  </td>
                </tr>
              </table>
            </div>

            <!-- Preview Section -->
            <!-- <div *ngIf="selectedFile" class="mt-4 border-t pt-4 pb-4 px-2">
              <div class="flex items-center justify-between mb-2">
                <span class="font-semibold text-sm truncate">
                  Preview: {{ selectedFile.file_provided_name || selectedFile.file_name }}
                </span>
                <button mat-icon-button (click)="selectedFile = null; previewUrl = null" size="small">
                  <mat-icon svgIcon="heroicons_outline:x" class="icon-size-4"></mat-icon>
                </button>
              </div>
              <div
                class="h-64 bg-gray-100 dark:bg-gray-900 rounded flex items-center justify-center relative overflow-hidden">
                <mat-progress-spinner
                  *ngIf="isPreviewLoading"
                  mode="indeterminate"
                  diameter="40"></mat-progress-spinner>
                <iframe
                  *ngIf="previewUrl && !isPreviewLoading"
                  [src]="previewUrl"
                  class="w-full h-full border-0 bg-white"></iframe>
                <div *ngIf="!previewUrl && !isPreviewLoading" class="text-center p-4">
                  <mat-icon
                    [svgIcon]="getFileIcon(selectedFile.file_extension)"
                    class="icon-size-10 text-gray-400 mb-2"></mat-icon>
                  <p class="text-xs">No preview available for this file type.</p>
                </div>
              </div>
            </div> -->
          </div>
        </cipx-scrollable-content>

        <div class="selected-files-container h-full min-h-0">
          <div class="selected-files-header">Selected Documents ({{ selectedFilesList.length }})</div>
          <div class="selected-files-list flex-1 overflow-y-auto min-h-0">
            @for (file of selectedFilesList; track file.file_id) {
              <div class="p-3 flex items-start justify-between gap-3">
                <div class="flex-1 min-w-0">
                  <div class="font-medium truncate text-sm" [title]="file.file_provided_name || file.file_name">
                    {{ file.file_provided_name || file.file_name }}
                  </div>
                  <div class="text-xs text-gray-500 truncate">{{ file.file_purpose_label }}</div>
                  <div class="text-xs text-gray-400">Order: {{ file.order_number }}</div>
                </div>
                <button mat-icon-button (click)="removeSelected(file.file_id)" aria-label="Remove">
                  <mat-icon svgIcon="heroicons_outline:trash" class="icon-size-5"></mat-icon>
                </button>
              </div>
            }
            @if (selectedFilesList.length === 0) {
              <div class="p-4 text-xs text-gray-500">No documents selected.</div>
            }
          </div>
        </div>
      </div>

      <cipx-action-bar [sticky]="false" [removeStickyOnMobile]="false" [justify]="'end'" class="mt-4">
        <cipx-cancel-button (buttonClick)="onCancel()">Cancel</cipx-cancel-button>
        <cipx-primary-button (buttonClick)="onAddSelected()" [disabled]="selectedFilesList.length === 0">
          Select
          {{
            selectedFilesList.length > 0
              ? selectedFilesList.length + (selectedFilesList.length > 1 ? ' Documents' : ' Document')
              : ''
          }}
        </cipx-primary-button>
      </cipx-action-bar>
    </div>
  </longlist-content>
</longlist>
